import { render, staticRenderFns } from "./FullpageLoader.vue?vue&type=template&id=15d8a993&scoped=true&"
import script from "./FullpageLoader.vue?vue&type=script&lang=js&"
export * from "./FullpageLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullpageLoader.vue?vue&type=style&index=0&id=15d8a993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8a993",
  null
  
)

export default component.exports